import { createFileRoute } from "@tanstack/react-router";
import FederalEmployeeInsuranceVerification from "@/pages/FederalEmployeeInsuranceVerification";
export const Route = createFileRoute(
  "/federal-employee-insurance-verification",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Federal Employee Insurance Verification | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Verify your FEHB insurance for TMS, SAINT TMS, and SPRAVATO coverage. Free benefits check for federal employees in Coral Springs, FL At Neuro Wellness TMS.",
        },
        {
          property: "og:title",
          content:
            "Federal Employee Insurance Verification | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Verify your FEHB insurance for TMS, SAINT TMS, and SPRAVATO coverage. Free benefits check for federal employees in Coral Springs, FL At Neuro Wellness TMS.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/federal-employee-insurance-verification",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/federal-employee-insurance-verification",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FederalEmployeeInsuranceVerification />;
}
